<script setup lang="ts">
import { computed } from 'vue';
import { formatDateTime, timeAgo } from '@/components/record/fields/formatFieldValue';

/**
 * A date and time in words: "Oct 12, 2026 at 10:19 PM". Hovering it says how
 * long ago that was. That is a convenience, so a touch screen without hover
 * loses nothing it needs.
 */
const props = defineProps<{ value: unknown }>();

const dateInput = computed(() =>
    typeof props.value === 'string' || typeof props.value === 'number' || props.value instanceof Date ? props.value : null,
);
const text = computed(() => (dateInput.value === null ? null : formatDateTime(dateInput.value)) ?? String(props.value));
const ago = computed(() => (dateInput.value === null ? undefined : timeAgo(dateInput.value) ?? undefined));
</script>

<template>
  <span data-testid="date-time-value" class="tabular-nums" :title="ago">{{ text }}</span>
</template>
